import React, { Component } from 'react';
import Swal from 'sweetalert2';
import NavBar from './navbar.js';
import Footer from './footer.js';
import { properties } from './properties.js';
import i18n from './I18N/I18n.js'; 
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { Link } from "react-router-dom";
import {logout, apiSecuredRequest, isUserOrWallet, isRootWallet, setBearer, cargarIdiomaPreferido} from './functions.js';
import './css/ToolMenu.css';
import DPP from './DPP/DPPGenerator.js';

class ToolMenu extends Component {

    async componentDidMount() {
        await cargarIdiomaPreferido(this.cambiarIdioma);
        const bearer = await this.checkIfWeb3UserOrLoginUser()
        this.cargarCamposMarca(bearer);
  
    }

    cambiarIdioma = (idioma) => {
      const { i18n } = this.props;
      i18n.changeLanguage(idioma); 
      this.forceUpdate(); 
      Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
    };
     

    logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
    }

    async checkIfWeb3UserOrLoginUser(){
        let params = (new URL(document.location)).searchParams;
        const certificadoId = params.get("certificadoId");
        const certificadoName = params.get("certificadoName");
        this.setState({ certificadoId })
        this.setState({ certificadoName })
        const empresa = JSON.parse(localStorage.getItem('empresa'));
        const empresaId = empresa.id;
        this.setState({ empresaId: empresaId })
        const empresaName = empresa.name;
        this.setState({empresaName})
        
        let empresaIdVar;
       
        let bearerVar;
        const urlInfo = window.location.pathname.split("/")
       
        this.setState({ empresaMapping: urlInfo[1] })
        const email = Cookies.get("email");
        this.setState({ email: email });
        bearerVar = Cookies.get("id");
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
        const direccion = Cookies.get("direccion");
        this.setState({direccion: direccion})
        
        let account = await isUserOrWallet(email, bearerVar);
        const bearerToken = await setBearer(email, bearerVar, account);
        this.setState({bearer: bearerToken})
        const isRootDir = await isRootWallet(account);
        this.setState({isRootDir: isRootDir});
        this.setState({account: account});

        if (isRootDir == true || userRol == properties.rootUserRol) {
          

          bearerVar =  Cookies.get('id');
          this.setState({ bearer: bearerVar });
          return bearerVar;
        }else{
      

          if(typeof bearerVar === 'undefined'){
                  Swal.fire({
                    title: `${i18n.t('connect')}`,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Finish'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      
                      window.location.href = `/`;
                      
                    }
                  });
            }else{
              
              bearerVar =  Cookies.get('id');
              this.setState({ bearer: bearerVar });
              return bearerVar;

          }
      

        }

    }

    async cargarCamposMarca(bearer) {

      let distinctCertificatesData = JSON.stringify({
        "certificadoId": `${this.state.certificadoId}`,
        "tipoStandard": ""
      });
      const camposDistintos= await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/campo/getCamposDistintos`, distinctCertificatesData, bearer);
      const campos =  camposDistintos.data;
      
      const DPP = campos.filter((campo) => campo.tipoCertificado == "DPP")[0]?.tipoCertificado || null;
      const DPP16 = campos.filter((campo) => campo.tipoCertificado == "DPP16")[0]?.tipoCertificado || null;
      const ochoCAMPOS = campos.filter((campo) => campo.tipoCertificado == "8CAMPOS")[0]?.tipoCertificado || null;
      const dieciseisCAMPOS = campos.filter((campo) => campo.tipoCertificado == "16CAMPOS")[0]?.tipoCertificado || null;
      
      if (DPP) {
        this.setState({ camposDPP: DPP });
      }
      
      if (DPP16) {
        this.setState({ camposDPP16: DPP16 });
      }
      
      if (ochoCAMPOS) {
        this.setState({ camposS8: ochoCAMPOS });
      }
      
      if (dieciseisCAMPOS) {
        this.setState({ camposS16: dieciseisCAMPOS });
      }
      
  }

    constructor(props) {
      super(props)
      this.state = {
        account: null, 
        isRootAddress: false,
        email: null, 
        bearer: null,
        camposS8: null, 
        camposS16: null,
        camposDPP: null, 
        camposDPP16: null,
        certificadoId: null,
        certificadoName: null,
        empresaId: null,
        empresaMapping: null,
        empresaName: null,
        userRol: null,
        direccion: null
      }
    }

    render() {

      if(this.state.empresaId != null && this.state.empresaMapping != null){
        return (
          <>
          
          <NavBar
  mail={this.state.email}
  bearer={this.state.bearer}
  logout={this.logout}
  cambiarIdioma={this.cambiarIdioma}
/>

<div className="content">
  <h1>{this.state.certificadoName}</h1>
  <button
    type="button"
    className="btn"
    onClick={() => {
      window.location.href = `/listaEmpresas`;
    }}
  >
    {i18n.t('back')}
  </button>
</div>
<p>{i18n.t('generateQuiestion')}</p>
<div className="option">
<div className="option">
  {this.state.camposDPP != null ? (
    <Link
      to={`/${this.state.empresaMapping}/DPP/DPPList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}`}
    >
      {i18n.t('DPPList')}
    </Link>
  ) : null}
</div>
<div className="option">
    {this.state.camposS16 != null ? (
      <Link
        to={`/${this.state.empresaMapping}/certificates/certificateList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}&standardType=16`}
      >
        {i18n.t('CertificateList')}
      </Link>
    ) : null}
  </div>

  <div className="option">
    {this.state.camposS16 != null ? (
      <Link
        to={`/${this.state.empresaMapping}/standard16/DPPList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}&standardType=16`}
      >
        {i18n.t('DppList')}
      </Link>
    ) : null}
  </div>


  <div className="option">
    {this.state.camposS16 != null ? (
      <Link
        to={`/${this.state.empresaMapping}/standard16/DPPGenerator?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}&standardType=16`}
      >
        {i18n.t('newS16NoUser')}
      </Link>
    ) : null}
  </div>

  <div className="option">
    {this.state.camposS16 != null ? (
      <Link
        to={`/${this.state.empresaMapping}/standard16/privateKeyGenerator?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}&standardType=16`}
      >
        {i18n.t('newS16')}
      </Link>
    ) : null}
  </div>
</div>

<Footer />

      
          </>
        );
      }
  
      }

}
export default withTranslation()(ToolMenu);